import { BrainIcon } from "lucide-react";

import { useI18n } from "~/i18n";
import { Button } from "../ui/button";
import { Tooltip, TooltipPopup, TooltipTrigger } from "../ui/tooltip";

export function MorrowMemoryToggleButton({
  active,
  onClick,
}: {
  readonly active: boolean;
  readonly onClick: () => void;
}) {
  const { t } = useI18n();

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            type="button"
            variant={active ? "default" : "outline"}
            size="sm"
            onClick={onClick}
            aria-pressed={active}
            title={t("memory.toggle")}
          >
            <BrainIcon aria-hidden="true" />
            {t("memory.title")}
          </Button>
        }
      />
      <TooltipPopup side="bottom">{t("memory.toggle")}</TooltipPopup>
    </Tooltip>
  );
}
